import React, { useState, useEffect } from "react";
import {$host} from "../http"
import { FaPlus } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { FaEllipsisV } from 'react-icons/fa';
import Header from '../components/Admin/Header'; // Импортируем Header
import Sidebar from '../components/Admin/Sidebar'; // Импортируем Sidebar
import { useNavigate } from 'react-router-dom';


const CourseManagementPage = () => {
  const navigate = useNavigate();

  const [courses, setCourses] = useState([]);
  const fetchCourses = async () => {
    try {
      const {data} = await $host("/api/public/courses");
      setCourses(data);
    } catch (error) {
      console.error("Ошибка загрузки курсов:", error);
    }
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [openMenuId, setOpenMenuId] = useState(null); // Состояние для хранения ID открытого меню

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMenuOpen && !event.target.closest('.menu-container')) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isMenuOpen]);

  // Функция для обработки удаления курса
  const handleDelete = async (courseId) => {
    const url = `/api/admin/courses/${courseId}`;

    try {
        const {data} = await $host.delete(url);

        await fetchCourses()

        navigate('/admin');

        console.log(`Курс с ID: ${courseId} успешно удалён`, data);
    } catch (error) {
        console.error('Ошибка:', error);
    }
};


  useEffect(() => {
    fetchCourses();
  }, []);

  return (
    <div>

<Header /> 



      <div className="flex min-h-screen bg-gray-100">
      
      <Sidebar /> {/* Используем компонент Sidebar */}

        {/* Main Content */}
        <main className="flex-1 p-8 bg-[#F3F1FB4D]">
          {/* Breadcrumbs */}
          <nav className="w-full rounded-md mb-8">
            <ol className="list-reset flex">
              <li>
              <Link to="/admin/courses" className="text-[black] text-primary transition duration-150 ease-in-out hover:text-primary-accent-300 focus:text-primary-accent-300 active:text-primary-accent-300 motion-reduce:transition-none dark:text-primary-400">
            Главная
          </Link>              </li>
            </ol>
          </nav>

          <h2 className="text-[42px] font-medium mb-4">Каталог курсов</h2>

          <div className="flex flex-wrap gap-4 bg-white rounded-lg shadow-lg p-6"
          style={{ maxHeight: '70vh', overflowY: 'auto' }}
          >
            {/* Блок для добавления курса */}
            <Link to="/admin/courses/add" className="flex flex-col items-center bg-[#6446C314] rounded-[16px] h-[210px] w-[280px] justify-center">
  <FaPlus className="text-2xl text-[#6446C3]" />
  <span className="mt-2 text-lg text-[#6446C3]">Добавить курс</span> {/* Optional: Add a label for clarity */}
</Link>


            {/* Блоки для курсов */}
            {courses && courses.map((course) => (
            <div key={course.id} 
            className="bg-white rounded-lg shadow-lg h-[210px] w-[280px] relative"
            >
            
            
            <div className="relative">
            <img 
  src={course.image_url ? course.image_url : "https://via.placeholder.com/280x140"} 
  alt={course.title} 
  className="w-full h-2/3 object-cover rounded-t-lg max-h-[123px]" 
/>               



<div className="absolute top-2 right-2"
     onMouseEnter={() => setOpenMenuId(course.id)} // Открытие меню при наведении
     onMouseLeave={() => setOpenMenuId(null)}> 

  <button 
    className="focus:outline-none"
    style={{
      backgroundColor: 'rgba(0, 0, 0, 0.5)', // Темный полупрозрачный фон
      borderRadius: '8px', // Округление 16px
      paddingLeft: '5px',
      paddingRight: '5px'
    }}
    >
    <FaEllipsisV className="text-white transform rotate-90" />
  </button>

  {/* Выпадающее меню */}
  {openMenuId === course.id && ( // Проверяем, открыто ли меню для этого курса
    <div className="absolute top-[-2px] right-0 w-40  bg-white shadow-lg"
    style={{ borderRadius: '8px', zIndex: 100 }}
    >
  <Link to={`/admin/courses/${course.id}`} className="text-center block px-4 py-2 text-gray-800">
    Редактировать
  </Link>
  <div className="flex justify-center">
  <div className="w-[80%] h-[1px] bg-[#6446C314]"></div>
</div>
  <div
        className="text-center block px-4 py-2 text-gray-800 cursor-pointer" 
        onClick={() => {
          handleDelete(course.id);
          setOpenMenuId(null); // Закрываем меню после удаления
        }}
      >
        Удалить
      </div>
</div>
  )}
</div>

              {/* Контейнер для кнопок */}
              <div className="absolute bottom-0 left-0 p-2 flex space-x-2">
                <span className="text-sm border border-gray-300 bg-[#D8D0FA] rounded-[8px] px-2 py-1">
                  
                {Array.isArray(course.students) && course.students.length > 0 
          ? `${course.students.length} учеников` 
          : 'Нет учеников'} {/* Проверка на наличие студентов */}
                </span>
      
              </div>
            </div>
            
            <div className="px-2 py-1">
            <Link to={`/admin/courses/${course.id}`}>
            <h3 className="text-lg font-medium text-gray-800 mb-2">{course.title}</h3>
            </Link>
              <p className="text-md font-medium text-gray-400 mb-2">{course.price}₽</p>
            </div>
          </div>
          
            ))}
          </div>
        </main>
      </div>
    </div>
  );
};

export default CourseManagementPage;
